
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M45.514 30.894c.32.32.481.69.481 1.106 0 .417-.16.786-.481 1.106L23.1 55.52c-.32.32-.69.48-1.106.48-.416 0-.785-.16-1.106-.48l-2.405-2.406c-.32-.32-.481-.69-.481-1.106 0-.416.16-.785.48-1.106L37.387 32 18.484 13.099c-.32-.32-.481-.69-.481-1.106 0-.418.16-.786.48-1.107L20.89 8.48c.32-.32.69-.48 1.106-.48.417 0 .786.16 1.106.48l22.413 22.413z","fill-rule":"nonzero"}})])
          )
        }
      }
    